import { forwardRef, useContext } from "react"
import { RegisterContext } from "../contexts/RegisterContext"
import { CheckboxAdvantage } from "./CheckboxAdvantage";
import { ParameterContext } from "../contexts/ParameterContext";


const CommonAdvantages = forwardRef(({ formData, handleChange }, ref) => {
    const { commonAdvantages } = useContext(RegisterContext);
    const { parameters } = useContext(ParameterContext);

    const label = parameters?.nomParameters.find(x => x.param_name == 'ADVANTAGES_LABEL');

    return (
        <>
            <div ref={ref} className="htext_ch">{label.value} критерии</div>

            <div className='children_data p-3-mob'>
                <div className="w-100 d-flex gap-3 flex-wrap ">
                    {commonAdvantages.map((x, i) => <CheckboxAdvantage key={ i} advatage={x} formData={formData} handleChange={handleChange} index={i} />)}
                </div>
            </div>
        </>
    )
})

export default CommonAdvantages;
